import React from "react";
import Image from "next/image";

function WeAreOnMoneyComponent() {
  return (
    <div className="max-w-[1200px] 4xl:max-w-[1800px] 4xl:h-auto m-auto grid xl:grid-cols-2 gap-0 md:gap-10 lg:gap-2 3xl:gap-36 4xl:gap-48 lg:grid-flow-col grid-flow-row md:items-center text-white lg:my-auto">
      <div className=" mx-auto lg:ml-0 text-center lg:text-left max-w-[380px] lg:max-w-[424px] 3xl:!w-[700px]  3xl:max-w-max">
        <h1 className="text-5xl lg:text-7xl 3xl:text-size-10 4xl:text-size-14 4xl:leading-130 mb-6 md:mb-spacing-9/2 4xl:mb-spacing-13 font-normal font-ppNeue mt-4 md:mt-0">
          We&apos;re on
          <br className="hidden md:block" /> the money
        </h1>
        <p className="text-base lg:w-[424px] 3xl:w-[550px] 4xl:w-[700px]  lg:text-2xl 3xl:text-size-4.9 4xl:text-size-5 4xl:leading-52 mb-8 4xl:mb-spacing-13">
          Onmo is one of the UK&apos;s <br className="hidden md:visible" /> most
          straightforward credit card providers
        </p>
      </div>
      <div className="relative md:h-full mx-auto mb-4 3xl:ml-5">
        <div className=" absolute -z-10 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[240px] h-[210px] xs:w-[250px] xs:h-[241px] md:w-[393px] md:h-[357px] bg-gradient-to-t from-onmoPurple-950 to-onmoPurple-800 from-10% opacity-60  border-2 border-onmoPurple-400 rounded-2xl " />

        <div className="flex flex-col w-[310px] xs:w-[350px] sm:w-[420px] md:w-[530px]  justify-between items-end px-4 md:px-0">
          <div className="w-56 sm:w-72 md:w-[393px]">
            <div className=" w-full h-auto shadow-[-8px_8px] shadow-onmoPurple-400 rounded-lg border-2 border-onmoPurple-400 bg-white">
              <div className="flex flex-col">
                <div className="flex justify-between pt-2 md:pt-3 pb-3 md:pb-6">
                  <div className="inline-block px-2 md:px-4">
                    <div className="text-gray-500 text-xs md:text-base font-ppNeue">
                      Balance
                    </div>
                    <div className="text-onmoPurple-900 text-md sm:text-lg md:text-xl font-normal">
                      £120.00
                    </div>
                  </div>
                  <div className="inline-block px-2 md:px-4">
                    <div className="text-gray-500 text-xs md:text-base font-ppNeue">
                      Available credit
                    </div>
                    <div className="text-onmoPurple-900 text-md sm:text-lg md:text-xl font-normal text-end">
                      £1,880.00
                    </div>
                  </div>
                </div>
                <div className="flex justify-evenly border-t-[1px] border-gray-200 pt-3 md:pt-6 pb-2 md:pb-3">
                  <div className="inline-block whitespace-nowrap text-onmoPurple-900 text-[10px] sm:text-xs md:text-base p-1 sm:p-2 px-1.5 sm:px-2 md:px-4 bg-onmoPurple-100 rounded-3xl ">
                    Account overview
                  </div>
                  <div className="inline-block whitespace-nowrap bg-onmoPrimary text-[10px] sm:text-xs md:text-base p-1 sm:p-2 px-1.5 sm:px-2 md:px-4 rounded-3xl">
                    Make a repayment
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="self-start py-8 w-56 sm:w-72 md:w-[393px]">
            <div className="shadow-[-8px_8px] shadow-onmoPurple-400 z-10 w-full rounded-lg border-2 border-onmoPurple-400 bg-white">
              <div className="flex justify-around py-4 md:py-6 items-center">
                <div className="inline-block justify-center text-center">
                  <div className="flex justify-center flex-col items-center">
                    <div className="w-8 md:w-12 h-8 md:h-12 flex justify-center items-center rounded-xl bg-onmoPurple-100 ">
                      <Image
                        src="/images/credit-card.png"
                        alt="credit-card"
                        className="w-4 h-4 sm:w-6 sm:h-6"
                        width={25}
                        height={25}
                      />
                    </div>
                    <span className="text-onmoPurple-900 text-[10px] sm:text-xs md:text-base">
                      Manage
                    </span>
                  </div>
                </div>
                <div className="inline-block justify-center text-center">
                  <div className="flex justify-center flex-col items-center">
                    <div className="w-8 md:w-12 h-8 md:h-12 flex justify-center items-center rounded-xl bg-onmoPurple-100 ">
                      <Image
                        src="/images/Document.png"
                        alt="statement"
                        className="w-4 h-4 sm:w-6 sm:h-6"
                        width={25}
                        height={25}
                      />
                    </div>
                    <span className="text-onmoPurple-900 text-[10px] sm:text-xs md:text-base">
                      Statements
                    </span>
                  </div>
                </div>
                <div className="inline-block justify-center text-center">
                  <div className="flex justify-center flex-col items-center">
                    <div className="w-8 md:w-12 h-8 md:h-12 flex justify-center items-center rounded-xl bg-onmoPurple-100 ">
                      <Image
                        src="/images/Charts.png"
                        alt="charts"
                        className="w-4 h-4 sm:w-6 sm:h-6"
                        width={25}
                        height={25}
                      />
                    </div>
                    <span className="text-onmoPurple-900 text-[10px] sm:text-xs md:text-base">
                      Insights
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-56 sm:w-72 md:w-[393px]">
            <div className="shadow-[-8px_8px] shadow-onmoPurple-400 z-10 w-full rounded-lg border-2 border-onmoPurple-400 bg-onmoPurple-50">
              <div className="flex flex-col px-4">
                <div className="flex justify-between pt-2 md:pt-3 pb-2 md:pb-4">
                  <div className="inline-block ">
                    <div className="text-gray-500 text-xs md:text-base font-ppNeue ">
                      Balance
                    </div>
                    <div className="text-onmoPurple-900 text-md sm:text-lg md:text-xl font-normal">
                      £120.00
                    </div>
                  </div>
                  <div className="inline-block ">
                    <div className="text-gray-500 text-xs md:text-base text-end font-ppNeue">
                      Credit limit
                    </div>
                    <div className="text-onmoPurple-900 text-md sm:text-lg md:text-xl font-normal text-end">
                      £2,000.00
                    </div>
                  </div>
                </div>
                <div className="rounded-xl pt-1 pb-3 md:pb-5">
                  <div className="flex">
                    <div className="w-[20%] h-4 md:h-6 bg-gradient-to-l to-onmoPurple-400 from-onmoPurple-900 rounded-l-md" />
                    <div className="w-[80%] h-2 md:h-6 bg-white rounded-r-md" />
                  </div>
                </div>
                <div className="flex justify-evenly border-t-2 border-gray-200 py-2 md:py-3">
                  <div className="text-gray-500 text-[10px] sm:text-xs md:text-base flex items-center whitespace-nowrap">
                    <Image
                      src="/images/Calendar.png"
                      alt="charts"
                      className="mr-2 w-3 sm:w-5 h-3 sm:h-5 "
                      width={15}
                      height={1}
                    />{" "}
                    7 days until next statement period
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WeAreOnMoneyComponent;
